var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinanceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F6F6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F3BA2F",
    fillRule: "evenodd",
    d: "m18.82 21.872 5.18-5.18 5.18 5.185 3.014-3.013-8.193-8.198-8.194 8.193 3.014 3.013Zm-8.153 2.126 3.013-3.013 3.013 3.013-3.013 3.013-3.013-3.013ZM24 31.308l-5.18-5.18-3.018 3.01.004.004 8.194 8.193 8.193-8.198h.005l-3.018-3.013L24 31.309Zm7.306-7.305 3.013-3.013 3.013 3.013-3.013 3.013-3.013-3.013Zm-7.306-3.064 3.056 3.062-3.056 3.061-3.057-3.057-.005-.004.005-.005.537-.537.261-.256 2.259-2.264Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceIcon);
export default __webpack_public_path__ + "static/media/binanceIcon.f601919a9df06da6d4d7cd197c23608c.svg";
export { ForwardRef as ReactComponent };